import { ContentType } from '@entries/content-types'
import ContentfulFootnoteSup from '@entries/contentful-footnote-sup'
import { withDisplayName } from '@hocs/with-display-name'
import { Entry } from '@resolvers/entry'
import React, { type FC } from 'react'

export type LegalMentionProps = {
  legalMention: Queries.ContentfulFootnoteSupFragment
}

export const LegalMention: FC<LegalMentionProps> = ({ legalMention }) => (
  <Entry
    content={legalMention}
    mapping={{
      [ContentType.ContentfulFootnote]: ContentfulFootnoteSup,
    }}
  />
)

export default withDisplayName(LegalMention, 'LegalMention')
